<template>
<div>
  <div :style="{width:'80%',margin:'100px auto'}">
     
  
      <div v-for="list in routerVal" class="indexButton_baoming" @click="jump(list.active)"><p>{{list.name}}</p> 录取通知书查询</div>
  </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
       routerVal:[
        {active:0,path:'/achievementMsg',name:'本专科'},
        {active:1,path:'/achievementMsg',name:'硕士研究生'},
        {active:2,path:'/achievementMsg',name:'博士研究生'},
        {active:3,path:'/achievementMsg',name:'留学生'},
        {active:4,path:'/achievementMsg',name:'成人教育'},
      ]
    }
  },
  watch:{
    
  },
  methods:{
    jump(QStype){
      //记录学生类型
      this.$store.state.QStype = QStype;
      this.$router.push('/enrollmentResult')

    }
  },

}
</script>
<style scoped>
.wellcome {
  color: #2d76f9;
  font-weight: 700;
  font-size: 20px;
}
.indexButton_baoming,.indexButton_chengji{
  height: 98px;
  width: 240px;
  margin: 40px 20px;
  background: linear-gradient(
    119.42deg,
    rgba(86, 204, 242, 1) 0%,
    rgba(45, 118, 249, 1) 100%
  );
   background: url("../assets/index/commit3.png") no-repeat top;
  background-size: 100% auto;
  border-radius: 6px;
  /* box-shadow: 0px 1.58px 1.51px rgba(182, 196, 250, 0.75); */
  color: white;
  font-weight: 500;
  font-size: 18px;
  /* line-height: 98px; */
  /* letter-spacing: 5px; */
  display: inline-block;
  cursor: pointer;
}

</style>